import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import Swal from 'sweetalert2';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Erro 401 - Não autorizado
      if (error.status === 401) {
        // Verificar se o usuário estava autenticado (tem token)
        const hadToken = !!localStorage.getItem('token');
        
        // Limpar dados de autenticação
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Rotas protegidas (painéis de usuário)
        const rotasProtegidas = ['/admin', '/farmacia', '/deposito', '/clinica', '/paciente', '/profissional'];
        const estaEmRotaProtegida = rotasProtegidas.some(rota => router.url.includes(rota));
        
        // Mostrar mensagem apenas se:
        // 1. Não estiver na página de login
        // 2. Estava autenticado (tinha token)
        // 3. Está em uma rota protegida
        if (!router.url.includes('/login') && hadToken && estaEmRotaProtegida) {
          Swal.fire({
            title: 'Sessão Expirada',
            text: 'Sua sessão expirou. Por favor, faça login novamente.',
            icon: 'warning',
            confirmButtonText: 'Ir para Login',
            allowOutsideClick: false
          }).then(() => {
            // Redirecionar para login
            router.navigate(['/login'], {
              queryParams: { returnUrl: router.url }
            });
          });
        } else if (estaEmRotaProtegida) {
          // Se está em rota protegida mas não tinha token, redirecionar silenciosamente
          router.navigate(['/login'], {
            queryParams: { returnUrl: router.url }
          });
        }
      }
      
      // Erro 403 - Acesso negado (apenas logar, não mostrar modal)
      else if (error.status === 403) {
        console.error('Acesso negado:', error.url);
      }
      
      // Erro 404 - Não encontrado (apenas logar)
      else if (error.status === 404) {
        console.error('Recurso não encontrado:', error.url);
      }
      
      // Erro 500 - Erro interno do servidor (apenas logar, não mostrar modal)
      else if (error.status === 500) {
        console.error('Erro no servidor:', error.url, error.error);
      }
      
      // Erro de rede (apenas logar, não mostrar modal)
      else if (error.status === 0) {
        console.error('Erro de conexão:', error.url);
      }

      return throwError(() => error);
    })
  );
};
